export { default as CONTACT_US } from './contactUs.mutation'
export * from './posts.mutation'
